import { call, put, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';

export function* create({ payload: { companyId, values } }) {
  try {
    const { data } = yield call(
      dataProvider.createOne,
      `companies/${companyId}/owner-working-hours/questions`,
      values,
    );
    yield put({
      type: currentCompany.ownerWorkingHoursQuestions.create.end,
      payload: { list: data },
    });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: e.message } });
    yield put({ type: currentCompany.ownerWorkingHoursQuestions.create.error });
  }
}

export default function* createWorkingHoursQuestionsSaga() {
  yield takeLatest(currentCompany.ownerWorkingHoursQuestions.create.start, create);
}
